import { render } from "./Users.vue?vue&type=template&id=1813faf3"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=1813faf3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/ddv-home/Users.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1813faf3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1813faf3', __exports__)) {
    api.reload('1813faf3', __exports__)
  }
  
  module.hot.accept("./Users.vue?vue&type=template&id=1813faf3", () => {
    api.rerender('1813faf3', render)
  })

}


export default __exports__